import { logger } from '@/util';
import callBackendApi from './call';

export interface EventTypeRecord {
  id: number;
  label: string;
}

export const getEventTypes = async (token: string, abortSignal?: AbortSignal) => {
  logger.debug('getEventTypes() called', {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/eventtypes`,
    abortSignal,
  });

  return data as EventTypeRecord[];
};
